import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import styles from "@/css/result.module.less";

// 计算延时图表需要偏离的百分比
const computerDelayPercent = (delay) => {
  let maxDelay = 500;
  const delayPer = delay >= maxDelay ? 1 : delay / maxDelay;

  return `${((1 - delayPer) * 100).toFixed(2)}%`;
};

const ChartInfo = ({
  data: {
    delay,
    downloadSpeed,
    uploadSpeed,
    uploadLineOptions,
    downloadLineOptions,
  },
}) => {
  return (
    <div className={styles["result-net-info-card"]}>
      <div className={styles["result-net-info-item"]}>
        <div className={styles["result-net-text"]}>
          <p className={styles["result-net-name"]}>延时/ms</p>
          <p className={`${styles["result-net-val"]} ${styles["val-delay"]}`}>
            {delay}
          </p>
        </div>
        <div className={`${styles["result-net-line"]} ${styles["line-delay"]}`}>
          <div
            className={styles["delay-fill-line"]}
            style={{ paddingRight: computerDelayPercent(delay) }}
          ></div>
        </div>
      </div>
      <div className={styles["result-net-info-item"]}>
        <div className={styles["result-net-text"]}>
          <p className={styles["result-net-name"]}>下载/Mbps</p>
          <p
            className={`${styles["result-net-val"]} ${styles["val-download"]}`}
          >
            {downloadSpeed}
          </p>
        </div>
        <div
          className={`${styles["result-net-line"]} ${styles["line-download"]}`}
        >
          <HighchartsReact
            highcharts={Highcharts}
            options={downloadLineOptions}
          />
        </div>
      </div>
      <div className={styles["result-net-info-item"]}>
        <div className={styles["result-net-text"]}>
          <p className={styles["result-net-name"]}>上传/Mbps</p>
          <p className={`${styles["result-net-val"]} ${styles["val-upload"]}`}>
            {uploadSpeed}
          </p>
        </div>
        <div
          className={`${styles["result-net-line"]} ${styles["line-upload"]}`}
        >
          <HighchartsReact
            highcharts={Highcharts}
            options={uploadLineOptions}
          />
        </div>
      </div>
    </div>
  );
};
export default ChartInfo;
